import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core'

import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { PopoverController } from '@ionic/angular'
import { slideOutRightAnimation } from 'angular-animations'
import mixpanel from 'mixpanel-browser'
import { AlertSupportComponent } from '../alert-support/alert-support.component'
import { AppState } from '../app.service'
import { Client } from '../client/client.model'
import { UserPublicProfileComponent } from '../components/user-public-profile/user-public-profile.component'
import { ContentSurveyStats } from "../content-survey/content-survey.model"
import { I18n } from '../i18n.service'
import { HomeUiService } from '../new-design/home-ui.service'
import { Path } from '../path/path-v2.model'
import { SpinnerService } from '../spinner.service'
import { ToasterService } from '../toaster.service'
import { User } from '../user/user.model'
import { StatService } from './stat.service'

  export interface ChartSettings {
  colour: string
  labels: string[]
  data: any
  greenDays: number[]
  realDay: number
}
@Component({
  selector: 'first90-stat-list',
  templateUrl: './stat-list.component.html',
  styleUrls: ['./stat-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    slideOutRightAnimation({duration: 500}),
  ]
})

export class StatListComponent implements OnInit, AfterViewInit {
  @Input() isHomeRoute: boolean;
  stats: object
  showing = 'leaderboard'
  client: Client
  path: Path
  currentUser: User
  loadingCounter = 0
  chartSettings: ChartSettings

  chartLabel : any;
  chartData : any;
  greenDay : any;

  scheduleDay: number
  realDay: number
  daysCompleted: number
  daysMissed: number
  daysRemining: number
  completions: any
  firstSurveyStats: ContentSurveyStats;
  leaderboardPosition: any
  statsTotal:any

  leaderboardEnabled: boolean
  checklistsEnabled: boolean
  pollsEnabled: boolean
  questionsEnabled: boolean
  documentsEnabled: boolean

  nameDP: string
  nameS: string
  nameL: string
  nameYD: string
  nameYDST: string
  nameT: string
  nameA: string
  nameAST1: string
  nameAST2: string
  namePQ: string
  nameAWP: string
  nameAWPST: string
  nameSP: string
  nameSPST: string
  nameR: string
  nameRST: string
  isMobile: boolean
  statList: any
  statByWeek: any

  thisPathUser: any
  thisPathUserRank: any
  thisWeekUser: any
  thisWeekUserRank: any
  allTimeUser: any
  allTImeUserRank: any

  thisPathFirst: any
  thisPathSecond: any
  thisPathThird: any

  thisWeekFirst: any
  thisWeekSecond: any
  thisWeekThird: any

  allTimeFirst: any
  allTimeSecond: any
  allTimeThird: any
  thisPathUserList: any
  isLoading=false;
  isMobileWebIos = false;
  isMobileWeb=false;
  thisPathLabel: string
  thisWeekLabel: string
  allTimeLabel: string
  currentTab = 0;
  startTime: any
  endTime: any
  leaderboardallTimeUsers;
  leaderboardPathUsers
  pathRegistration;
  options: [
    {
      label: 'Sliding Entrances',
      animations: ['slideOutRight']
    },
  ]
  animationState = false;

  constructor(
    private appState: AppState,
    private statService: StatService,
    private spinnerService: SpinnerService,
    private matDialog: MatDialog,
    private popoverController:PopoverController,
    private i18n: I18n,
    private toasterService: ToasterService,
    private router:Router,
    public homeUiService: HomeUiService,
  ) {
    this.thisPathLabel = this.i18n.t('This Cycle')
    this.thisWeekLabel = this.i18n.t('This Week')
    this.allTimeLabel = this.i18n.t('All Time')
    this.client = this.appState.get('currentClient')
    this.path = this.appState.get('currentPath')
    this.currentUser = this.appState.get('currentUser')
    this.pathRegistration = this.appState.get('pathRegistration')
    this.isMobile = this.appState.get('isMobile')
    this.loadingCounter = 0
   // this.areEnabled()
    //this.initNames()
    this.getStats(this.path.id)
    
  }



  ngOnInit() {
    this.startTime = new Date();
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
  }
  async openUserInfo(ev, userData): Promise<void> {
    const popover = await this.popoverController.create({
      component: UserPublicProfileComponent,
      event: ev,
      mode:'ios',
      translucent: false,
      componentProps: {'user': userData}
    });
    await popover.present();
   
  }
  ngAfterViewInit() {
    this.homeUiService.expandOnEnterAnimation()
  }

  toggleSettingDisplay(setting) {
    this.showing = setting
  }

  getArray(value: number): Array<any> {
    return new Array(value)
  }

  onView(event) {
    return false
  }
  private areEnabled() {
    this.leaderboardEnabled = this.path.enabledAttributes['leaderboard']
    this.checklistsEnabled = this.path.enabledAttributes['checklists']
    this.pollsEnabled = this.path.enabledAttributes['polls']
    this.questionsEnabled = this.path.enabledAttributes['questions']
    this.documentsEnabled = this.path.enabledAttributes['documents']
  }

  private initNames() {
    this.nameDP = this.path.getCustomText('h_dp')
    this.nameS = this.path.getCustomText('s_s')
    this.nameL = this.path.getCustomText('s_l')
    this.nameYD = this.path.getCustomText('s_yd')
    this.nameYDST = this.path.getCustomText('s_yd_st')
    this.nameT = this.path.getCustomText('s_t')
    this.nameA = this.path.getCustomText('s_a')
    this.nameAST1 = this.path.getCustomText('s_a_st_1')
    this.nameAST2 = this.path.getCustomText('s_a_st_2')
    this.namePQ = this.path.getCustomText('s_pq')
    this.nameAWP = this.path.getCustomText('s_awp')
    this.nameAWPST = this.path.getCustomText('s_awp_st')
    this.nameSP = this.path.getCustomText('s_sp')
    this.nameSPST = this.path.getCustomText('s_sp_st')
    this.nameR = this.path.getCustomText('s_r')
    this.nameRST = this.path.getCustomText('s_r_st')
  }

  getStats(pathId){
    if (this.router.url === '/main/stats') {
      this.spinnerService.on();
    }
    this.statService.getLeaderboardKyperList(pathId)
    .subscribe(response => {
      this.stats = response?.data
      this.statsTotal = response?.data?.activities?.total
      if (this.router.url === '/main/stats') {
        this.spinnerService.off();
      }
       this.leaderboardPathUsers = this.stats?.['this_path']
          this.statByWeek = this.stats?.['this_week']
          this.leaderboardallTimeUsers = this.stats?.['all_time']
          this.getCurrentUser(this.stats, this.statByWeek)
      // this.getStatsByWeek(pathId,this.stats)
    },
      (error) => {
      if (this.router.url === '/main/stats') {
        this.spinnerService.off();
      }
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
      this.stats = error
    })
  //commenting this api as we are not using any of the param inside of it
  // this.statService.getKyperUserParticipation().subscribe(
  //   response => {
  //     // this.spinnerOff()
  //     this.leaderboardPosition = response?.data?.userlist?.findByIndex((user)=>user.id ==this.currentUser?.id)
  //     // this.scheduleDay = response.scheduleDay
  //     // const firstSurvey = this.statService.findFirstSurvey(this.fetchScreenTypeContent('contentSurveys'), this.scheduleDay);
  //     // if (firstSurvey) {
  //     //   this.firstSurveyStats = firstSurvey.getStats();
  //     // }
  //     // this.completions = response.completions
  //     // this.realDay = response.realDay
  //     // const duration = response.data.length
  //     // const lastCompletedDay = response.greenDays[response.greenDays.length - 1]
  //     // this.daysCompleted = response.scheduleDay - (lastCompletedDay === this.realDay ? 0 : 1)
  //     // this.daysMissed = this.realDay - this.scheduleDay
  //     // // this.daysRemining = this.path.lastDayOfContent() - response.scheduleDay
  //     // this.daysRemining = this.path.lastDayOfContent() - this.daysCompleted
  //     // const cutResponse = this.statService.cutParticipationData(response);
  //     // this.chartSettings = {
  //     //   colour: this.path.colours['theme'],
  //     //   labels: cutResponse.labels,
  //     //   data: cutResponse.data,
  //     //   greenDays: response.greenDays,
  //     //   realDay: this.realDay
  //     // }
      
  //   }
  // )
  }
  // thisPathClick($event) {
  //   mixpanel.track("Leaderboard Tab Changed", {value: 'Yes'})
  //   console.log("mixpanel", this.thisPathClick($event) )
  // }

  fetchScreenTypeContent(screentype) {
    let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  getStatsByWeek(pathId:number, stats:any=null){ 
    const requestData = {
      'path_id': pathId
    }

    if(!requestData){
      this.spinnerService.off();
    }else{
      this.statService.getListStatsByWeek(requestData).subscribe(
        (response) => {
          this.leaderboardPathUsers = stats.leaderboard.current_path_user
          this.statByWeek = response.data
          this.leaderboardallTimeUsers = stats.leaderboard.users
          this.getCurrentUser(stats, this.statByWeek)
        },
        (error) => {
          console.log('error for stats by week', error);
        }
      )
    }
  }

  goToQuestion(){
    var supportDialog = this.matDialog.open(AlertSupportComponent);
    supportDialog.afterClosed().subscribe()
  }

  getCurrentUser(stats: any, statsByWeek: any){
    var current_path_user=[]
    current_path_user = stats?.['this_path']

    try {
      this.thisPathUserList = stats?.['this_path']
      let currentUserStats = stats?.['current_user_positions'];
      let userPosition =stats?.['user_position']?.length>0?stats?.['user_position']?.[0]:stats?.['user_position']
      this.isLoading=true;
      // this.thisPathUserRank = current_path_user.findIndex(element=> element.isMe)
      // let thisUser = current_path_user.filter(element=> element.isMe)
      // this.thisPathUser = thisUser?.length>0?thisUser[0]:null

      // this.thisWeekUserRank = statsByWeek.findIndex(element=> element.id === this.currentUser.id)
      // let thiWeekUser = statsByWeek.filter(element=> element.id === this.currentUser.id)
      // this.thisWeekUser = thiWeekUser?.length>0?thiWeekUser[0]:null

      // this.allTImeUserRank = stats.leaderboard.users.findIndex(element=> element.isMe === true)
      // let allTimeUser = stats.leaderboard.users.filter(element=> element.isMe === true)
      // this.allTimeUser = allTimeUser?.length>0?allTimeUser[0]:null
      this.thisPathUserRank = currentUserStats?.current_path_position;
      this.thisPathUser = { ...userPosition }
      this.thisPathUser.actionPoints =currentUserStats?.current_path_action_points
      this.thisWeekUser = { ...userPosition }
      this.thisWeekUser.actionPoints =currentUserStats?.weekly_action_points
      this.allTimeUser = { ...userPosition }
      this.allTimeUser.actionPoints =currentUserStats?.all_time_action_points
      this.thisWeekUserRank = currentUserStats?.weekly_position
      this.allTImeUserRank = currentUserStats?.all_time_position

      this.thisPathFirst = current_path_user?.length>0?current_path_user[0]:null
      this.thisPathSecond = current_path_user?.length>1?current_path_user[1]:null
      this.thisPathThird = current_path_user?.length>2?current_path_user[2]:null

      this.thisWeekFirst = statsByWeek?.length>0?statsByWeek[0]:null
      this.thisWeekSecond = statsByWeek?.length>1?statsByWeek[1]:null
      this.thisWeekThird = statsByWeek?.length>2?statsByWeek[2]:null

      let all_time_user = stats?.['all_time']
      this.allTimeFirst = all_time_user?.length>0?all_time_user[0]:null
      this.allTimeSecond = all_time_user?.length>1?all_time_user[1]:null
      this.allTimeThird = all_time_user?.length>2?all_time_user[2]:null
      console.log("thisPathUser...",this.thisPathUser,currentUserStats,currentUserStats?.current_path_action_points)
    } catch (error) {
      console.log('error catch', error);
      
    }
  }
  leaderboardTabChanged($event) {
    this.currentTab = $event.index;
    this.endTime = new Date();
    let timeDiff = this.endTime - this.startTime; // time difference in milliseconds
    let seconds = Math.floor(timeDiff / 1000); // convert to seconds
    let minutes = Math.floor(seconds / 60); // convert to minutes
    let hours = Math.floor(minutes / 60); // convert to hours
    let timeSpent = hours + ":" + minutes + ":" + seconds; // format the time spent
    mixpanel.track('Leaderboard- Tab change', {'Tabs active': this.currentTab == 0 ? 'THIS CYCLE' : this.currentTab == 1 ? 'THIS WEEK': this.currentTab == 2 ? 'ALL TIME' : '', 'time spent': timeSpent})
    localStorage.setItem('leaderboardTab', this.currentTab.toString());
   //this.onChange();
  }
  receiveState(event: any){
    setTimeout(() => {
      this.animationState = event
    }, 10);
  }

}
